import * as StudentActions from '../actions/studentActions';

const defaultState = {
    location: [],
    logins: []
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case StudentActions.ACTION_STUDENT_LOCATION:
            return {
                ...state,
                location: action.payload
            };
        case StudentActions.GOT_LOGINS:
            return {
                ...state,
                logins: action.payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/studentReducer.js